<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 24.75h-2.76l-3.48-8a2 2 0 00-1.84-1.2H43V11a2 2 0 00-2-2H7a2 2 0 00-2 2v27a2 2 0 002 2h6.94a7.48 7.48 0 0014.12 0h8.38a7.48 7.48 0 0014.12 0H57a2 2 0 002-2V26.75a2 2 0 00-2-2zM21 42a4.5 4.5 0 114.5-4.5A4.51 4.51 0 0121 42zm22.5 0a4.5 4.5 0 114.5-4.5 4.51 4.51 0 01-4.5 4.5zM56 37h-5a7.49 7.49 0 00-15 0h-7.53a7.49 7.49 0 00-14.94 0H8V12h32v12.5a1.5 1.5 0 003 0v-6h5.26l4 9.25H56zM57.5 48h-51a1.5 1.5 0 000 3h51a1.5 1.5 0 000-3z"/></svg>